import { render, staticRenderFns } from "./DriverSignup.vue?vue&type=template&id=464f2af4&scoped=true&"
import script from "./DriverSignup.vue?vue&type=script&lang=js&"
export * from "./DriverSignup.vue?vue&type=script&lang=js&"
import style0 from "@/scss/auth.scss?vue&type=style&index=0&id=464f2af4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464f2af4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VTextField})
